module.exports = [{"type":"hash","text":"權限設置"},{"type":"normal","text":"","children":[{"type":"normal","text":"新創建的API的默認權限是 只讀。"},{"type":"normal","text":"如果需要通過API進行下單交易等寫操作，需要在UI修改為對應權限。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/authentication/02_permission_set.json
// module id = U3vK
// module chunks = 3